import { useState } from 'react'
import GameLayout from '../components/game/GameLayout'
import GameMap from '../components/game/GameMap'
import UnitsPanel from '../components/game/UnitsPanel'
import BattleHistory from '../components/game/BattleHistory'
import StructuresPanel from '../components/game/StructuresPanel'
import ModsPanel from '../components/game/ModsPanel'
import MissionsPanel from '../components/game/MissionsPanel'
import { Map, Swords, Package, Building2, Wrench, Target } from 'lucide-react'

type Tab = 'map' | 'battle' | 'units' | 'structures' | 'mods' | 'missions'


export default function Game() {
  const [activeTab, setActiveTab] = useState<Tab>('map')

  const tabs = [
    { id: 'map' as Tab, label: 'Map', icon: Map },
    { id: 'battle' as Tab, label: 'Battle', icon: Swords },
    { id: 'units' as Tab, label: 'Units', icon: Package },
    { id: 'structures' as Tab, label: 'Build', icon: Building2 },
    { id: 'mods' as Tab, label: 'Mods', icon: Wrench },
    { id: 'missions' as Tab, label: 'Missions', icon: Target },
  ]

  return (
    <GameLayout>
      {/* Main Content Area */}
      <div className="absolute inset-0 overflow-hidden" style={{ paddingBottom: 'calc(3.5rem + env(safe-area-inset-bottom, 0px))' }}>
        {activeTab === 'map' && <GameMap />}
        {activeTab === 'battle' && <BattleHistory />}
        {activeTab === 'units' && <UnitsPanel />}
        {activeTab === 'structures' && <StructuresPanel />}
        {activeTab === 'mods' && <ModsPanel />}
        {activeTab === 'missions' && <MissionsPanel />}
      </div>

      {/* Bottom Navigation - Mobile First */}
      <nav className="fixed bottom-0 left-0 right-0 z-50 bg-slate-900/95 backdrop-blur-xl border-t border-white/10 safe-area-bottom">
        <div className="flex items-center justify-around h-14">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex-1 h-full flex flex-col items-center justify-center gap-0.5 transition-all duration-300 relative ${
                activeTab === tab.id
                  ? 'text-cyan-400'
                  : 'text-slate-500 active:text-slate-300'
              }`}
            >
              {activeTab === tab.id && (
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 bg-cyan-400 rounded-full" style={{ boxShadow: '0 0 8px rgba(34, 211, 238, 0.6)' }} />
              )}
              <tab.icon className={`w-5 h-5 transition-all duration-300 ${activeTab === tab.id ? 'drop-shadow-[0_0_8px_rgb(34,211,238)]' : ''}`} />
              <span className="text-[10px] font-medium">{tab.label}</span>
            </button>
          ))}
        </div>
      </nav>
    </GameLayout>
  )
}
